<template>
  <div @click="$emit('selected', gate.gate);"
       @mouseover="highlightsDisabled ? undefined : highlightElement({type: types.gate, id: gate.gate})"
       @mouseleave="clearAllHighlights" class="highlight-trigger">
    <b-card class="my-2 cursor-pointer border-primary">

      <div class="d-flex align-items-center">

        <div>
          <div class="num-box float-left text-center cursor-pointer"
               :class="`${extraNumBoxClasses || ''}`">
            {{gate.gate}}
          </div>
        </div>
        <div>
          <label class="font-weight-light">{{gate.name }}</label>
          <h6>{{gate.keynote}}</h6>
        </div>
        <div class="ml-auto">
          <svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 13L7 7L0.999999 1" :stroke="darkMode ? '#fff' : '#191c23'" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
      </div>

    </b-card>
  </div>
</template>
<script>

import HighlightingMixin from "@/mixins/HighlightingMixin";

export default {
  mixins: [HighlightingMixin],
  props: {
    gate: Object,
    extraNumBoxClasses: String,
    highlightsDisabled: {
      type: Boolean,
      default: false
    }
  }
}
</script>